import { useRef } from "react";
import { Outlet, useParams } from "react-router-dom";
import type { RecenzjaInfo } from "@shared/recenzjeTypy.js";
import { NiewaznyLink } from "../../components/recenzja/NiewaznyLink.js";
import { PowlokaRecenzji } from "../../components/recenzja/PowlokaRecenzji.js";
import { useStartStronyPoZmianieTrasy } from "../../components/shell/useStartStronyPoZmianieTrasy.js";
import { useZasob, type StanZasobu } from "../../hooks/useZasob.js";
import { recenzjaApi } from "../../lib/recenzjaApi.js";

/** To, co uklad linku (/r/:token) przekazuje stronom pod spodem przez Outlet. */
export interface KontekstUkladuRecenzji {
  token: string;
  /** Lista rozmow pod linkiem (te sama odpowiedz karmi naglowek z etykieta i strone glowna). */
  info: StanZasobu<RecenzjaInfo>;
}

/**
 * Uklad wspolny dla calego linku recenzenta: powloka z naglowkiem i wczytanie listy rozmow RAZ, bo etykieta "Recenzja:
 * <dla kogo>" w naglowku jest potrzebna takze na stronie pojedynczej rozmowy (otwartej wprost z zakladki), a ta
 * odpowiedz o etykiecie nie mowi.
 *
 * Link nieznany, wygasly albo uniewazniony (404 `link_nieprawidlowy`) zastepuje cala zawartosc jedna, przyjazna strona.
 */
export function UkladRecenzji(): React.JSX.Element {
  const { token = "" } = useParams();
  const info = useZasob<RecenzjaInfo>(`info:${token}`, () => recenzjaApi.info(token));
  const refGlownego = useRef<HTMLElement>(null);

  // Przejscie miedzy lista a rozmowa zaczyna sie od gory strony, jak nowa strona, a fokus, ktory zginal razem ze
  // kliknietym linkiem, laduje na <main> (czytnik ekranu oglasza nowy widok). To ten sam mechanizm co w AppShell.
  useStartStronyPoZmianieTrasy(refGlownego);

  const niewazny = info.blad === "link_nieprawidlowy";
  const kontekst: KontekstUkladuRecenzji = { token, info };

  return (
    <PowlokaRecenzji etykieta={niewazny ? null : (info.dane?.etykieta ?? null)} refGlowny={refGlownego}>
      {niewazny ? <NiewaznyLink /> : <Outlet context={kontekst} />}
    </PowlokaRecenzji>
  );
}
